export default function ContactInfo() {
  const contactMethods = [
    {
      icon: 'ri-map-pin-line',
      title: 'Visit Us',
      content: '218/89 High Street',
      subcontent: 'Kew VIC 3101, Australia',
      link: 'https://maps.google.com/?q=218/89+High+Street+Kew+VIC+3101+Australia'
    },
    {
      icon: 'ri-phone-line',
      title: 'Call Us',
      content: '+61 3 9008 6321',
      subcontent: 'Mon-Fri: 9:00 AM - 6:00 PM AEST',
      link: 'tel:+61390086321'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email Us',
      content: 'info@nexapods.com.au',
      subcontent: 'We reply within 24 hours',
      link: 'mailto:info@nexapods.com.au'
    }
  ];



  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-b from-[#0D1117] to-[#000000]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Contact Methods */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-16">
          {contactMethods.map((method, index) => (
            <a
              key={index}
              href={method.link}
              target={method.link.startsWith('http') ? '_blank' : undefined}
              rel={method.link.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="group bg-gradient-to-br from-gray-900/50 to-black/50 backdrop-blur-xl border border-cyan-500/20 rounded-2xl p-8 hover:border-cyan-400/50 transition-all hover:shadow-[0_0_40px_rgba(0,217,255,0.2)] cursor-pointer"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-full mb-4 group-hover:shadow-[0_0_30px_rgba(0,217,255,0.4)] transition-all">
                  <i className={`${method.icon} text-3xl text-cyan-400`}></i>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{method.title}</h3>
                <p className="text-base text-gray-300 mb-1">{method.content}</p>
                <p className="text-sm text-gray-400">{method.subcontent}</p>
              </div>
            </a>
          ))}
        </div>

        {/* Map */}
        <div className="bg-gradient-to-br from-gray-900/50 to-black/50 backdrop-blur-xl border border-cyan-500/20 rounded-2xl overflow-hidden h-[400px]">
          <iframe
            src="https://maps.google.com/maps?q=89%20High%20Street%2C%20Kew%20VIC%203101%2C%20Australia&z=16&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Office Location"
          ></iframe>
        </div>
      </div>
    </section>
  );
}